import { MrbBaseListViewStore } from "mrb/core";
import { MrbTableViewStore } from "mrb/components";
import { mrbDefaultFormats } from "mrb/common/formatting";

class LoadioArtistListViewStore extends MrbBaseListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, {
            queryConfig: {
                orderBy: "name",
                orderDirection: "asc",
            },
        });
        this.routeStore = routeStore;

        this.setGridStore(
            new MrbTableViewStore(this.rootStore, this.queryUtility, {
                onRowClick: (node) =>
                    this.rootStore.routerStore.goTo("master.administration.loadio.artist.preview", {
                        id: node.data.id,
                    }),
                columns: [
                    {
                        key: "name",
                        title: "ADMINISTRATION.LOADIO.LIST.COLUMNS.ARTIST",
                        sortable: true,
                    },
                    {
                        key: "isActive",
                        title: "ADMINISTRATION.LOADIO.LIST.COLUMNS.STATUS",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Active",
                            falseLabel: "Inactive",
                        },
                    },
                    {
                        key: "isDeleted",
                        title: "ADMINISTRATION.LOADIO.LIST.COLUMNS.DROPBOX_STATUS",
                        format: {
                            type: mrbDefaultFormats.bool,
                            trueLabel: "Deleted",
                            falseLabel: "Available",
                        },
                    },
                ],
            })
        );
    }

    find(params) {
        return this.routeStore.findLoadioArtists(params);
    }

    onFetchError() {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to load data. Please contact the support team."
        );
    }
}

export default LoadioArtistListViewStore;
